import React, { Component } from "react";
import { connect } from "react-redux";

export class DashboardMain extends Component {
  render() {
    return (
      <div>
        <p>I am a Dashboard</p>
        <p>Work In Progress</p>
      </div>
    );
  }
}

export default connect(null, dispatch => ({}))(DashboardMain);



// WEBPACK FOOTER //
// ./src/components/dashboard/main.js